<template>
  <div>
    <div v-if="historyDisplayed" class="excursion-history">
      <hr class="mt-4 hr" />
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-title id="excursion-history--expansion--header">
            Revision Points
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <template #default>
              <v-row v-for="(item, index) in historyItems" :key="index" class="revision-row">
                <v-col cols="4">
                  <cs-button
                    primary
                    label="Select Revision"
                    @click="openRevisionDialog(historyItems[0].computed.reversionIndex)"
                  ></cs-button>
                </v-col>
                <v-col cols="4"> {{ item['audit-metadata']['userDisplayName'] }} </v-col>
                <v-col cols="4" justify="justify-end" align="end">
                  {{ item.timestamp }}
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <cs-form-dialog
      id="dlg-student-management-revert"
      v-model="groupRevertGenericDialogDisplayed"
      heading="Student Management - Select Revision"
      body-id="group-import-modal--generic-dialog"
      :primary-action="{
        label: 'Revert',
        eventName: 'primary-click',
        disabled: revertInProgress
      }"
      :secondary-action1="{ label: 'Cancel', eventName: 'secondary1-click' }"
      @primary-click="studentMangementRevert"
      @secondary1-click="cancelRevisionBtnClick"
    >
      <template #cs-form-dialog-content>
        <v-spacer></v-spacer>
        {{ groupRevertGenericDialogMessage }}
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      id="dlg-student-management-generic"
      v-model="genericDialogDisplayed"
      heading="Student Management - Select Revision Status"
      body-id="group-import-modal--generic-dialog"
      :primary-action="{ label: 'OK', eventName: 'primary-click' }"
      @primary-click="genericDialogOkBtnClick"
    >
      <template #cs-form-dialog-content>
        <v-spacer></v-spacer>
        <div v-safe-html="genericDialogMessage"></div>
      </template>
    </cs-form-dialog>
  </div>
</template>

<script>
import * as types from '@/store/mutationTypes';
import { populateErrorMessage } from '../lib/errorMessages';

export default {
  name: 'StudentManagementHistory',

  data() {
    return {
      groupRevertGenericDialogMessage: 'Are you sure you want to revert the group mapping?',
      groupRevertGenericDialogDisplayed: false,
      reversionIndex: '',
      genericDialogMessage: '',
      successRevisionMessage: 'Revert student management successfully.',
      revisionErrorMessage: 'Revision failed, please try again.',
      genericDialogDisplayed: false,
      revertInProgress: false
    };
  },
  computed: {
    historyDisplayed() {
      return this.$store.state.common.studentManagementAuditList.length > 0;
    },
    historyItems() {
      return this.$store.state.common.studentManagementAuditList;
    }
  },
  async mounted() {
    const cbResponse = await this.$app.stbApiAdapter.getAuditStudentMangement({
      store: this.$store
    });
    if (!cbResponse.error) {
      this.$store.commit(types.COMMON_SET_STUDENT_MANAGEMENT_AUDIT_LIST, cbResponse);
    }
  },
  methods: {
    async studentMangementRevert() {
      this.groupRevertGenericDialogDisplayed = false;
      this.revertInProgress = true;
      const argHash = {
        index: this.reversionIndex,
        store: this.$store
      };
      const cbResponse = await this.$app.stbApiAdapter.putStudentGroupManagementReversion(argHash);
      this.revertInProgress = false;
      if (!cbResponse.error) {
        this.genericDialogMessage = this.successRevisionMessage;
      } else {
        this.genericDialogMessage = `${this.revisionErrorMessage}: ${cbResponse.message}.`;

        this.genericDialogMessage = populateErrorMessage({
          message: this.genericDialogMessage,
          store: this.$store
        });
      }
      setTimeout(() => {
        this.genericDialogDisplayed = true;
      }, 200);
    },
    openRevisionDialog(index) {
      this.groupRevertGenericDialogDisplayed = true;
      this.reversionIndex = index;
    },
    cancelRevisionBtnClick() {
      this.groupRevertGenericDialogDisplayed = false;
      this.reversionIndex = '';
    },
    genericDialogOkBtnClick() {
      this.genericDialogDisplayed = false;
      this.$app.window.location.reload();
    }
  }
};
</script>
<style scoped>
.revision-row {
  border-bottom: 1px solid rgb(var(--v-theme-secondary));
  align-items: center;
}

.excursion-history {
  width: 100%;
}

.excursion-history .theme--light.v-expansion-panel .v-expansion-panel__container {
  background: inherit;
}

.excursion-history .theme--light.v-list {
  background: inherit;
}

.excursion-history .list-action-created-date {
  margin-top: -25px;
}

.excursion-history .hr {
  margin-bottom: 0px;
}

.excursion-history .v-expansion-panel {
  box-shadow: none;
  margin-bottom: 0px;
}

.excursion-history .detail-line {
  text-transform: capitalize;
}
</style>
